export default "__VITE_ASSET__C5GF8DZA__"